import axios from 'axios'

// const API_URL = 'https://new.backinthegame.gr/api/web'
// const API_URL = 'http://localhost:8081/api/web'
const API_URL = process.env.VUE_APP_API_HOST_DOMAIN

const headers = {
    'Content-Type': 'application/json; charset=utf-8'
}
// The server speaks HTTP/1.1, where the browser opens at most 6 connections to it and the live
// pages keep 4 of them for their event streams: a GET that never answers would hold one of the
// last free connections for good and every later request (e.g. the break-screen slides) would queue
// behind it. Uploads and saves keep no time limit
const GET_TIMEOUT_MS = 15000
const formDataHeaders = {
    'Content-Type': 'multipart/form-data'
}
export default {
    post(urlPath, data) {
        return this.request(urlPath, 'POST', headers, data)
    },
    put(urlPath, data) {
        return this.request(urlPath, 'PUT', headers, data)
    },
    get(urlPath) {
        return this.request(urlPath, 'GET', headers, null)
    },
    delete(urlPath) {
        return this.request(urlPath, 'DELETE', headers, null)
    },
    getFile(urlPath, fileName) {
        window.open(API_URL + urlPath, '_blank')
    },
    uploadFile(urlPath, formData) {
        return this.request(urlPath, 'POST', formDataHeaders, formData)
    },
    request(urlPath, method, headers, data) {
        data = data || {}
        headers = headers || {}

        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + '/' + urlPath,
                data: data,
                method: method,
                headers: headers,
                timeout: method === 'GET' ? GET_TIMEOUT_MS : 0
            }).then(function(response) {
                const contetType = response.headers['content-type']
                if (contetType && contetType.indexOf('application/json') > -1) {
                    return response
                } else {
                    resolve()
                }
            }).then((data) => {
                resolve(data)
            }).catch((error) => {
                if (!error.response) {
                    // eventBus.$emit('sessionExpired')
                }
                reject(error)
            })
        })
    }
}
